import { pagingToParams } from 'modules/utils';
import { axiosInstance } from './axios';
import { REACT_APP_API_SERVER_URL } from './constants';

export const getCountries = async () => {
  const response = await axiosInstance.get(
    `${REACT_APP_API_SERVER_URL}/api/gemicro-code/country`,
  );

  const { data } = response;

  return {
    country: data,
  };
};

export const getCitiesByCountryCode = async (countryCode: string) => {
  const postalParams = pagingToParams({});
  postalParams.append('countryCode', countryCode);

  const response = await axiosInstance.get(
    `${REACT_APP_API_SERVER_URL}/api/gemicro-code/postal`,
    { params: postalParams },
  );

  const { data } = response;

  return {
    city: data,
  };
};
